import { render, staticRenderFns } from "./vacancy-form.vue?vue&type=template&id=2d871c66"
import script from "./vacancy-form.vue?vue&type=script&lang=js"
export * from "./vacancy-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports